import BuilderVM from './builder-vm';
import WizardPage from 'libs/wizard-page';
import WizardStepNav from 'libs/wizard-step-nav';

export default {
  panelConfig: {
    GeneralInfoPage: {
      step: 1,
      i18nPath: '.general_info',
      icon: 'info',
      validate: viewModel => viewModel.validate(false)
    },

    GradingCriteriaPage: {
      step: 2,
      i18nPath: 'dict.grading_criteria',
      icon: 'star',
      validate: viewModel => viewModel.validate(true)
    },

    SubmissionRequirementsPage: {
      step: 3,
      i18nPath: '.submission_requirements',
      icon: 'link',
      validate: viewModel => viewModel.validate(true)
    },

    AssociatedAssetsPage: {
      step: 4,
      i18nPath: '.associated_assets',
      icon: 'upload',
      validate: viewModel => viewModel.validate(true)
    },

    ReviewPage: {
      step: 5,
      i18nPath: '.review',
      icon: 'checkmark',
      validate: _viewModel => true
    },

    ExternalAssignmentPage: {
      step: 'lti',
      i18nPath: '.lti_information',
      icon: 'info',
      validate: viewModel => {
        if (viewModel.coursework().external_application_id()) {
          return [];
        } else {
          return ['External Application is required.'];
        }
      }
    },

    ExternalAssignmentLaunchPage: {
      step: 'lti-launch',
      i18nPath: '.lti_configuration',
      icon: 'info',
      validate: viewModel => viewModel.validate(false)
    },
  },

  panels: [],
  currentPanelIdx: 0,
  requiredCourseworkTypesForSave: ['LinkAssignment', 'ExternalAssignment'],

  init() {
    this.initializePanels()
    this.initializeViewModel()
    this.applyViewModelBindings()
    this.initializeStepProgress()
    this.showSelectionPanel()
  },

  initializePanels() {
    Object.keys(this.panelConfig).forEach(panelName => {
      const panelOptions = this.panelConfig[panelName]

      const panelId = isNaN(panelOptions.step) ?
        this.namedPanelDomId(panelOptions.step) :
        this.numberedPanelDomId(panelOptions.step)

      const i18nPath = panelOptions.i18nPath.match(/^\./) ?
        `wizard${panelOptions.i18nPath}` :
        panelOptions.i18nPath

      const iconName = `kf-${panelOptions.icon}`

      this[panelName] = function() { this.init.apply(this, arguments) } // notice new `this` context!

      this[panelName].prototype = Kadenze.Util.extendClass(WizardPage, {
        id: panelId,
        name: I18n.t(i18nPath),
        icon: iconName,
        validate: panelOptions.validate
      })
    })

    this.panels = [
      new this.GeneralInfoPage(),
      new this.GradingCriteriaPage(),
      new this.SubmissionRequirementsPage(),
      new this.AssociatedAssetsPage(),
      new this.ReviewPage()
    ]
  },

  initializeViewModel() {
    this.viewModel = new BuilderVM($('#coursework_json').val(), this)

    if (!this.viewModel.isSubmittable())
      this.removeSubmissionRequirementsPage()

    if (this.courseworkType() === 'ExternalAssignment') {
      this.addExternalAssignment()
      this.removeGradingCriteria()
    }
  },

  initializeStepProgress() {
    // Init progress bar AFTER ko binds with the DOM so it can get the accurate step count

    this.stepProgress = new WizardStepNav(
      $('#js-wizardNav'),
      this,
      {
        numVisible: 1,
        pages: this.panels,
        breakpoints: {
          xs: 1,
          sm: 2,
          lg: 3
        }
      }
    )
  },

  applyViewModelBindings() {
    ko.applyBindingsWithValidation(
      this.viewModel,
      $('#js-cw-submission')[0],
      {
        insertMessages: true,
        errorsAsTitle: true,
        decorateInputElement: true,
        parseInputAttributes: true,
        messagesOnModified: true,
        errorElementClass: 'error',
        errorMessageClass: 'error_message',
        decorateElementOnModified: true,
        decorateElement: true,
        grouping: { deep: true, observable: true, live: true }
      }
    )
  },

  nextPage() {
    if (!this.isLastPage()) {
      this.currentPanelIdx++

      while(!this.viewModelIsEnabledInCurrentPanel()) {
        this.currentPanelIdx++
      }

      this.showCurrentPanel()
    }
  },

  previousPage() {
    if (!this.isFirstPage()) {
      this.currentPanelIdx--

      while(!this.viewModelIsEnabledInCurrentPanel()) {
        this.currentPanelIdx--
      }

      this.showCurrentPanel()
    }
  },

  isFirstPage() { return this.currentPanelIdx === 0 },
  isLastPage() { return this.currentPanelIdx === this.panels.length - 1 },

  addExternalAssignment() {
    this.panels.splice(1, 0, new this.ExternalAssignmentPage());
    this.panels.splice(2, 0, new this.ExternalAssignmentLaunchPage());
  },

  removeGradingCriteria() { this.removePanelByNumber(2) },
  removeSubmissionRequirementsPage() { this.removePanelByNumber(3) },

  removePanelByNumber(panelId) {
    if (this.getPanelIndexByNumber(panelId))
      this.panels.splice(this.getPanelIndexByNumber(panelId), 1)
  },

  getPanelIndexByNumber(num) {
    const i = this.panels.findIndex(({ id }) => id === this.numberedPanelDomId(num))
    return i > -1 ? i : null
  },

  numberedPanelDomId(panelId) {
    return `js-cw-step${panelId}`
  },

  namedPanelDomId(panelId) {
    return `js-cw-${panelId}-step`
  },

  showSelectionPanel() {
    this.showPanelByIndex(0)
  },

  currentPanel() {
    return this.panels[this.currentPanelIdx]
  },

  showCurrentPanel() {
    this.showPanelByIndex(this.currentPanelIdx)
  },

  showPanelByIndex(index) {
    if (this.viewModelNeedsSave(index)) {
      const response = this.viewModel.save($('#wizard-container'));

      response.success(() => this.showPanel(this.panels[index]))

      response.error((xhr, textStatus, errorThrown) => {
        new Kadenze.Notice.error(
          Object.assign({}, this.defaultNoticeOptions, { message: xhr.responseJSON.errors })
        )
      })
    } else {
      this.showPanel(this.panels[index]);
    }
  },

  showPageByIndex(i) { this.showPanelByIndex(i) },

  showPanel(panel) {
    const $panel = $('#' + panel.id)

    this.currentPanelIdx = this.panels.indexOf(panel)
    this.hideAllSubPages()

    $panel.stop(true, true).fadeIn() // show subpage by page id

    this.stepProgress.setActiveStepByIndex(this.currentPanelIdx)
    this.viewModel.initStepUI(panel.id)
  },

  hideAllSubPages() {
    $('.coursework-new__step').stop(true, true).hide()
  },

  viewModelNeedsSave(index) {
    return this.courseworkSaveIsRequired() && index > 0
  },

  courseworkSaveIsRequired() {
    return !this.courseworkPersisted() && this.isRequiredCourseworkTypeForSave()
  },

  courseworkPersisted() {
    return !!this.viewModel.coursework().id()
  },

  isRequiredCourseworkTypeForSave() {
    return this.requiredCourseworkTypesForSave.includes(this.courseworkType())
  },

  courseworkType() {
    return this.viewModel.coursework().type()
  },

  viewModelIsEnabledInCurrentPanel() {
    return this.currentPanel().isEnabled(this.viewModel)
  },
}
